import { GET_AUTH_TOKEN, DELETE_AUTH_TOKEN, DELETE_AUTH_USER, GET_AUTH_USER } from '../mutation-types'

const state = {
  token: null,
  user: {}
}

const mutations = {
  [GET_AUTH_TOKEN] (state, token) {
    state.token = token
  },
  [GET_AUTH_USER] (state, user) {
    state.user = user
  },
  [DELETE_AUTH_TOKEN] (state) {
    state.token = null
  },
  [DELETE_AUTH_USER] (state) {
    state.user = {}
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/auth.js